export default "__VITE_ASSET__9H1wVlsV__"